// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3v_2u","file":"styles_file__3SyH5"};